module.exports = __webpack_public_path__ + "img/t-22981-009.c67f2a65.jpg";